import { Box, Stack, Typography } from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt";
import { useSelector } from "react-redux";
import { getDeepViewValuesEntry } from "../../deepViewFieldMap";
import { renderDeepViewText } from "../../renderDeepViewText";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const NCOorFCPA = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const offsetType = deepViewData?.period?.offset_type;
  const stage6Text = getDeepViewValuesEntry(
    deepViewData,
    columnKey,
  )?.stage6_prefilled;

  const heading =
    offsetType === "fenced_cpa"
      ? "Fenced CPA Applied"
      : "Negative Carry Over (NCO) Applied";

  return (
    <Box
      sx={{
        border: "1px solid #0288D180",
        borderRadius: "8px",
        backgroundColor: "#0288D10A",
        p: 1,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <BoltIcon
          sx={{
            color: "#01579B",
            fontSize: 18,
          }}
        />

        <Typography
          sx={{
            color: "#01579B",
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {heading}
        </Typography>
      </Stack>

      <Typography
        sx={{
          color: "#01579B",
          fontSize: "14px",
          lineHeight: "20px",
        }}
      >
        {renderDeepViewText(stage6Text)}
      </Typography>
    </Box>
  );
};

export default NCOorFCPA;
